export const ORDER_SURFACE_PATHS = ["/orders", "/orders-display"];

export function isOrderSurfacePath(pathname) {
  return ORDER_SURFACE_PATHS.includes(pathname);
}

export const ORDERS_SURFACE_ACTIVE_EVENT = "ordersSurfaceActive";
